import { get, post, put } from 'utils/methods';

export function getDiscountsApi(data, headers) {
    return get(`${process.env.REACT_APP_REST}discounts`, data, headers);
}

export function addNewDiscountApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/discount`, data, headers);
}

export function editDiscountApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/discount`, data, headers);
}

export function updateTranslateDiscountApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/discount/translate`, data, headers);
}
